/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secure_Encrypted_CheckoutInputs */

const en_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Encrypted Checkout`)
};

const es_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago Seguro Cifrado`)
};

const fr_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement Sécurisé et Crypté`)
};

const de_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer, verschlüsselter Checkout`)
};

const ja_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全な暗号化チェックアウト`)
};

const zh_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全加密结账`)
};

const ar_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دفع آمن ومشفر`)
};

const id_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran Terenkripsi Aman`)
};

const it_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout Sicuro e Crittografato`)
};

const ru_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасная Зашифрованная Оплата`)
};

const pt_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout Seguro e Encriptado`)
};

const ko_secure_encrypted_checkout = /** @type {(inputs: Secure_Encrypted_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전하게 암호화된 결제`)
};

/**
* | output |
* | --- |
* | "Secure Encrypted Checkout" |
*
* @param {Secure_Encrypted_CheckoutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const secure_encrypted_checkout = /** @type {((inputs?: Secure_Encrypted_CheckoutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secure_Encrypted_CheckoutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secure_encrypted_checkout(inputs)
	if (locale === "es") return es_secure_encrypted_checkout(inputs)
	if (locale === "fr") return fr_secure_encrypted_checkout(inputs)
	if (locale === "de") return de_secure_encrypted_checkout(inputs)
	if (locale === "ja") return ja_secure_encrypted_checkout(inputs)
	if (locale === "zh") return zh_secure_encrypted_checkout(inputs)
	if (locale === "ar") return ar_secure_encrypted_checkout(inputs)
	if (locale === "id") return id_secure_encrypted_checkout(inputs)
	if (locale === "it") return it_secure_encrypted_checkout(inputs)
	if (locale === "ru") return ru_secure_encrypted_checkout(inputs)
	if (locale === "pt") return pt_secure_encrypted_checkout(inputs)
	return ko_secure_encrypted_checkout(inputs)
});